import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: '', key: 'imageUrl' },
      { label: t('name'), key: 'name' },
      { label: 'SKU', key: 'skuNo' },
      { label: 'UPC', key: 'upc' },
      { label: t('lastUpdate'), key: 'lastUpdate' },
      { label: t('regularPrice'), key: 'regularPrice' },
      { label: t('discountedPrice'), key: 'promoPrice' },
      { label: t('promoEnd'), key: 'expirationDate' },
    ],
    [t],
  );
};
